export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_male_Cn.cd4aa6d6.webp";